import { useEffect, useState, useRef } from "react";
import { summarySocketurl } from "../config/index";
import ImgMaximize from "../assets/maximize.png";
import ImgMinimize from "../assets/minimize.png";

const Summary = ({ productId, maximized, minimized, onMaximizeClick }) => {
  const [summary, setSummary] = useState("");
  const socket = useRef(null);

  useEffect(() => {
    if (!productId) return;

    socket.current = new WebSocket(`${summarySocketurl}/${productId}`);

    socket.current.onopen = () => {
      console.log("Open Summary");
    };
    socket.current.onmessage = (event) => {
      let data = JSON.parse(JSON.parse(event.data));
      if (data?.message === "invalid payload") {
        setSummary("No summary found");
      } else {
        setSummary(data?.message);
      }
    };
    socket.current.onerror = (error) => console.log(error);
    socket.current.onclose = (event) => console.log(event);

    return () => {
      socket.current?.close();
    };
  }, [productId]);

  return (
    <div
      className={`ai-section d-flex flex-column ${
        maximized ? "" : "summary-collapsed"
      } ${minimized ? "" : "border"}`}
      style={{
        height: minimized ? 0 : "100%",
      }}
    >
      {/* HEADER */}
      <div className="section-header d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
        <h4 className="mb-0">Summary</h4>

        <button
          className="btn btn-sm"
          onClick={onMaximizeClick}
          title={maximized ? "Minimize" : "Maximize"}
        >
          <img src={maximized ? ImgMinimize : ImgMaximize} alt="full-screen" />
        </button>
      </div>

      <div
        className="summary p-3 flex-grow-1"
        style={{
          display: minimized ? "none" : "block",
        }}
      >
        {summary ? (
          <p className="mb-0">{summary}</p>
        ) : (
          <span className="typing-indicator">
            Generating Summary
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </span>
        )}
      </div>
    </div>
  );
};

export default Summary;
